import React from "react";
import { number, func, instanceOf, string, bool } from "prop-types";
import { Form } from "react-bootstrap";
import { getYear, addYears, subYears } from "date-fns";
import DatePickerInput from "../DatePickInput";
import TimePickInput from "../TimePickInput";
import EventExpirationByDays from "./EventExpirationByDays";

const SetEventExpiration = ({
  selectedEventExpiration,
  setSelectedEventExpiration,
  eventExpirationDays,
  handleTestExpirationDropdown,
  eventExpirationDate,
  handleEventExpirationDateChange,
  eventExpirationTime,
  setEventExpirationTime,
  showEventExpirationTimeError,
  fromSchedulingEventExpiration,
  fromExtendEventExpiration,
}) => {
  const isEventExpirationDays = selectedEventExpiration === "days";
  const isEventExpirationDateTime = selectedEventExpiration === "dateTime";

  const eventExpirationRadioOnChange = (e) => {
    setSelectedEventExpiration(e.currentTarget.value);
  };

  const selectedEventExpirationDaysClassName = `selectEventExpirationByDays ${
    isEventExpirationDays ? "selectedEventExpiration" : ""
  }`;

  const selectedEventExpirationDateTimeClassName = `selectEventExpirationByDateTime ${
    isEventExpirationDateTime ? "selectedEventExpiration" : ""
  }`;

  return (
    <>
      <div className={selectedEventExpirationDaysClassName}>
        <Form.Check type="radio" className="setEventExpirationRadioBtn" inline>
          <Form.Check.Input
            type="radio"
            onChange={eventExpirationRadioOnChange}
            checked={isEventExpirationDays}
            value="days"
          />
          <Form.Check.Label
            style={{ fontWeight: "bold", color: "#1c1c1c", marginLeft: "5px" }}
          >
            By Number of Days
          </Form.Check.Label>
        </Form.Check>
        {isEventExpirationDays && (
          <EventExpirationByDays
            eventExpirationDays={eventExpirationDays}
            handleTestExpirationDropdown={handleTestExpirationDropdown}
            fromSchedulingEventExpiration={fromSchedulingEventExpiration}
            fromExtendEventExpiration={fromExtendEventExpiration}
          />
        )}
      </div>
      <div className={selectedEventExpirationDateTimeClassName}>
        <Form.Check type="radio" className="setEventExpirationRadioBtn" inline>
          <Form.Check.Input
            type="radio"
            onChange={eventExpirationRadioOnChange}
            checked={isEventExpirationDateTime}
            value="dateTime"
          />
          <Form.Check.Label
            style={{ fontWeight: "bold", color: "#1c1c1c", marginLeft: "5px" }}
          >
            By Specific Date & Time
          </Form.Check.Label>
        </Form.Check>
        {isEventExpirationDateTime && (
          <div className="mt-2 ml-4 d-flex align-items-start">
            <DatePickerInput
              handleDateChange={handleEventExpirationDateChange}
              dateValue={eventExpirationDate}
              disabled={{
                before: new Date(),
              }}
              fromYear={getYear(subYears(new Date(), 1))}
              toYear={getYear(addYears(new Date(), 2))}
            />
            <TimePickInput
              timeValue={eventExpirationTime}
              handleTimeChange={setEventExpirationTime}
              showEventExpirationTimeError={showEventExpirationTimeError}
              fromExtendEventExpiration={fromExtendEventExpiration}
            />
          </div>
        )}
      </div>
    </>
  );
};

SetEventExpiration.propTypes = {
  selectedEventExpiration: string.isRequired,
  setSelectedEventExpiration: func.isRequired,
  eventExpirationDays: number,
  handleTestExpirationDropdown: func,
  eventExpirationDate: string,
  handleEventExpirationDateChange: func,
  eventExpirationTime: instanceOf(Date),
  setEventExpirationTime: func,
  showEventExpirationTimeError: bool,
  fromSchedulingEventExpiration: bool,
  fromExtendEventExpiration: bool,
};

export default SetEventExpiration;
